
import React, { useEffect, useState } from "react";
import Button from "../common/Button/Button";
import api from "../../services/api";
import { toast } from "react-toastify";
import styles from "./AccessRights.module.css";

const AddAccessRights = ({ rightId, onSubmitted, onCancel }) => {
    const id = rightId;
    const [roles, setRoles] = useState([])
    const [types, setTypes] = useState([])
    const [formData, setFormData] = useState({
        access_types: "",
        access_roles: "",
        access_portal: "",
        view: false,
        create: false,
        modify: false,
        delete: false
    });

    const fetchRoles = async () => {
        try {
            const res = await api.get(`/access-roles`)
            if (res.data) {
                setRoles(res.data)
            }
        } catch (error) {
            toast.error(error?.message || 'Error fetching roles')
        }

    }

    const fetchTypes = async () => {
        try {
            const res = await api.get(`/access-types`)
            if (res.data) {
                setTypes(res.data)
            }
        } catch (error) {
            toast.error(error?.message || 'Error fetching types')
        }
    }

    useEffect(() => {
        Promise.all([
            fetchRoles(),
            fetchTypes()
        ])
    }, [])

    useEffect(() => {
        if (id) {
            api.get(`/access-types/${id}`)
                .then((res) => {

                    const role = res.data;
                    if (role) {
                        setFormData({
                            access_types: role.access_types_id || "",
                            access_roles: role.access_roles_id || "",
                            access_portal: role.access_portal || "",
                            view: role.view === "Yes" ? true : false,
                            create: role.create === "Yes" ? true : false,
                            modify: role.modify === "Yes" ? true : false,
                            delete: role.delete === "Yes" ? true : false,

                        });
                    }
                })
                .catch((err) => console.error("Error loading access type:", err));
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: checked
        }))
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            access_types: formData.access_types,
            access_roles: formData.access_roles,
            access_portal: formData.access_portal,
            view: formData.view === true ? "Yes" : "No",
            create: formData.create === true ? "Yes" : "No",
            modify: formData.modify === true ? "Yes" : "No",
            delete: formData.delete === true ? "Yes" : "No"
        }

        const apiCall = id
            ? api.put(`/access-rights/${id}`, payload)
            : api.post(`/access-rights`, payload);

        apiCall
            .then(() => { if (onSubmitted) onSubmitted(); })
            .catch((error) => console.error("Error:", error));
    };

    return (
        <div className="moduleFormContainer">
            <div className="moduleFormCard">


                <form onSubmit={handleSubmit} className="moduleForm">

                    <div className="formGrid">
                        <div className="formGroup">
                            <label>Access Roles</label>
                            <select
                                name="access_roles"
                                value={formData.access_roles || ""}
                                onChange={handleChange}
                                required
                            >
                                <option value="" >Access Roles</option>
                                {roles.map((chapter) => (
                                    <option key={chapter.id} value={chapter.id}>
                                        {chapter.role_type}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="formGroup">
                            <label>Access Types</label>
                            <select
                                name="access_types"
                                value={formData.access_types || ""}
                                onChange={handleChange}
                                required
                            >
                                <option value="" >Access types</option>
                                {types.map((chapter) => (
                                    <option key={chapter.id} value={chapter.id}>
                                        {chapter.access_types}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="formGroup">
                            <label>Access Portal</label>
                            <select
                                name="access_portal"
                                value={formData.access_portal || ""}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Portal</option>
                                <option value="Frontend">Frontend</option>
                                <option value="Admin Panel">Admin Panel</option>
                            </select>
                        </div>

                        <div className={styles.checkboxWrapper}>
                            <label htmlFor="create">Create Page</label>
                            <input
                                id="create"
                                type="checkbox"
                                name="create"
                                checked={formData.create}
                                onChange={handleCheckboxChange}
                            />
                        </div>
                        <div className={styles.checkboxWrapper}>
                            <label htmlFor="view">View Page</label>
                            <input
                                id="view"
                                type="checkbox"
                                name="view"
                                checked={formData.view}
                                onChange={handleCheckboxChange}
                                
                            />
                        </div>
                        <div className={styles.checkboxWrapper}>
                            <label htmlFor="modify">Modify Page</label>
                            <input
                                id="modify"
                                type="checkbox"
                                name="modify"
                                onChange={handleCheckboxChange}
                                checked={formData.modify}
                            />
                        </div>
                        <div className={styles.checkboxWrapper}>
                            <label htmlFor="delete">Delete Page</label>
                            <input
                                id="delete "
                                type="checkbox"
                                name="delete"
                                onChange={handleCheckboxChange}
                                checked={formData.delete}
                            />
                        </div>

                    </div>

                    <div className="formActions">
                        <Button type="submit" className="submitButton">{id ? "Update" : "Submit"}</Button>
                        <button type="button" className="backButton" onClick={onCancel}>
                            Cancel
                        </button>
                    </div>

                </form>

            </div>
        </div>
    );
};

export default AddAccessRights;